var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 374,
    viewBox: "0 0 317 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.344 122.573C206.263 121.622 207.432 121.107 208.074 121.814C269.041 188.972 308.836 275.7 316.917 371.46C316.973 372.122 316.378 372.654 315.726 372.524C275.183 364.464 233.52 359.513 190.995 357.929C190.367 357.905 189.915 357.317 190.055 356.704C202.496 302.293 209.077 245.593 209.077 187.329C209.077 165.512 208.151 143.914 206.344 122.573Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.988 0.887912C159.122 -0.205554 160.667 -0.322849 160.947 0.742599C176.598 60.2523 184.945 122.8 184.945 187.33C184.945 245.635 178.129 302.319 165.271 356.607C165.164 357.06 164.759 357.378 164.294 357.376C163.242 357.371 162.189 357.368 161.136 357.368C106.343 357.368 52.8563 362.959 1.21367 373.599C0.286842 373.79 -0.367792 372.706 0.232576 371.974C84.9331 268.78 141.774 141.097 158.988 0.887912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmada);
export default __webpack_public_path__ + "static/media/armada.c2995805155d67aad41fc4ee38593e27.svg";
export { ForwardRef as ReactComponent };